import styled from "@mui/styled-engine-sc";

export const SpaceContainer = styled("div")`
  display: flex;
  column-gap: 32px;

  ${({ theme }) => `
    ${theme.breakpoints.down("sm")} {
      flex-direction: column;
      row-gap: 12px;
    }
  `}
`;

export const Card = styled("div")`
  min-height: 300px;
  border-radius: 8px;
  width: 100%;
  max-width: 700px;
  padding: 24px;
  text-align: center;
  color: white;
`;

export const StyledChip = styled("span")`
  display: inline-block;
  text-transform: uppercase;

  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 4px 8px;
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 24px;
`;

export const CardTitle = styled("a")`
  display: block;
  font-weight: 900;
  font-size: 40px;
  line-height: 44px;
  margin-bottom: 24px;
`;

export const CardDesc = styled("div")`
  font-weight: 600;
  font-size: 14px;
  line-height: 23px;
`;

export const Button = styled("button")`
  font-family: inherit;
  border: none;
  cursor: pointer;
  display: inline-block;
  margin-top: 32px;
  background-color: #ffffff;
  font-weight: 700;
  text-decoration: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 14px;
  transition: 0.2s ease;
  &:hover {
    background-color: #f2f2f2;
  }
`;
